import type { TechniqueEntry } from '../schema';

export const readinessElicitation: TechniqueEntry = {
  key: 'readiness_elicitation',
  version: '0.1',
  name: 'Readiness elicitation',
  pillar: 'MI',
  serves:
    "Hearing, in the member's own words, how they feel about making this change right now: the live reading that calibrates everything downstream (planning pace, discrepancy eligibility, which exercises fit).",
  method: [
    'Ask the readiness question in its own turn, and wait. Do not move to summary, insight, or plan until it is answered.',
    'Read the answer against the stages of change (precontemplation through maintenance, including after a relapse) and match the approach: someone unsure needs curiosity, not a plan; someone ready to act needs encouragement, concrete next steps, and their own strengths reflected back.',
    'The onboarding goal is the standing readiness signal (honour a stop-completely goal, surface the trigger for a cut-back goal, stay exploratory for understand-patterns, light-touch for figuring-out or not-sure); this technique refreshes that signal live rather than trusting it stale.',
  ],
  never: [
    'Never skip it when a plan is about to be shaped.',
    'Never argue the member into more readiness or contradict their self-assessment.',
    'Never treat the onboarding goal as current without checking.',
  ],
  requiresFirst: [
    {
      kind: 'conversation',
      clause: 'Enough conversation that the question does not land cold.',
    },
  ],
  doneWhen:
    "Their readiness stated in their own words, and the conversation's pace visibly matched to it.",
  firstMove: 'How do you feel about making this change right now, in your own words?',
  exemplars: [],
  appliesTo: ['base', 'journey'],
  programs: null,
  signature: null,
  source:
    'agents/intake/sona-v2/prompt.md (exact readiness question, own-turn rule), shared/sections/base_objective.md, welcome_objective.md (stages-of-change matching)',
};
